var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIronLogoblancosinfondo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 966.93 283.46",
    style: {
      enableBackground: "new 0 0 966.93 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 52.94,
    y: 110.53,
    className: "st0",
    width: 31.82,
    height: 103.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.77,110.53h60.6c18.07,0,33.78,10,33.78,29.55c0,10.73-5,21.98-15.49,25.94 c8.67,3.29,13.99,12.83,15.13,25.7c0.46,5.06,0.61,17.38,3.48,22.17h-31.8c-1.6-5.23-2.19-10.55-2.64-15.91 c-0.82-9.86-1.73-20.15-14.34-20.15h-16.89v36.06H96.77V110.53z M128.61,155.74h16.61c5.94,0,14.08-1.04,14.08-10.3 c0-6.51-3.64-10.25-15.81-10.25h-14.88V155.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.99,108.08c31.4,0,52.41,22.61,52.41,54.12c0,31.54-21,54.17-52.41,54.17 c-31.37,0-52.38-22.62-52.38-54.17C196.61,130.68,217.62,108.08,248.99,108.08 M248.99,190.61c8.1,0,20.56-5.36,20.56-28.42 c0-22.99-12.45-28.35-20.56-28.35c-8.12,0-20.53,5.36-20.53,28.35C228.46,185.25,240.87,190.61,248.99,190.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "310.63,110.53 343.18,110.53 373.3,165.85 373.61,165.85 373.61,110.53 403.7,110.53 403.7,213.9  372.73,213.9 341.04,157.45 340.75,157.45 340.75,213.9 310.63,213.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M501.45,213.85h-6.77l-1.2-18.28h-0.27c-6.6,14.35-19.82,20.38-33.94,20.38c-30.87,0-46.31-24.87-46.31-52.22 c0-27.43,15.44-52.28,46.31-52.28c20.62,0,37.39,11.4,40.96,33.32h-9.36c-1.19-11.52-12.9-25.13-31.6-25.13 c-25.95,0-36.95,22.18-36.95,44.09c0,21.89,11,44.04,36.95,44.04c21.73,0,34.34-15.57,33.94-36.78h-33.39v-8.14h41.63V213.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.34,113.6h44.9c16.19,0,29.77,8,29.77,26.12c0,12.62-6.43,23.03-19.07,25.54v0.3 c12.79,1.67,16.5,10.63,17.2,22.6c0.41,6.88,0.41,20.64,4.47,25.69h-10.31c-2.27-3.93-2.27-11.38-2.56-15.58 c-0.82-14.08-1.95-29.62-19.65-28.91h-35.44v44.49h-9.33V113.6z M524.67,161.17h34.88c11.4,0,21.13-7.28,21.13-19.47 c0-12.24-7.1-19.96-21.13-19.96h-34.88V161.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M643.87,111.46c30.8,0,46.18,24.85,46.18,52.28c0,27.35-15.38,52.22-46.18,52.22 c-30.89,0-46.25-24.87-46.25-52.22C597.63,136.31,612.98,111.46,643.87,111.46 M643.87,207.78c25.84,0,36.84-22.16,36.84-44.04 c0-21.91-11-44.09-36.84-44.09c-25.97,0-36.91,22.18-36.91,44.09C606.96,185.62,617.91,207.78,643.87,207.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M699.53,113.6h9.37v62.04c-0.21,23.31,10.72,32.14,28.69,32.14c18.12,0,28.99-8.83,28.83-32.14V113.6h9.36 v64.17c0,20.65-10.86,38.18-38.19,38.18c-27.2,0-38.05-17.53-38.05-38.18V113.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M790.46,113.6H834c17.58,0,29.13,10.54,29.13,28.63c0,18.1-11.55,28.63-29.13,28.63h-34.2v42.98h-9.33V113.6z  M799.8,162.75h32.13c12.92,0,21.86-6.76,21.86-20.51c0-13.79-8.95-20.5-21.86-20.5H799.8V162.75z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 847.63,
    y: 52.28,
    className: "st0",
    width: 28.4,
    height: 28.38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 906.36,
    y: 81.51,
    className: "st0",
    width: 28.39,
    height: 28.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 877.98,
    y: 111.48,
    className: "st0",
    width: 28.38,
    height: 28.46
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronLogoblancosinfondo);
export default __webpack_public_path__ + "static/media/IRON_Logo blanco sin fondo.dafe6a5ce10fc75d593fe32c775f9fbd.svg";
export { ForwardRef as ReactComponent };